import { Controller } from "@hotwired/stimulus"

// Ticks once per second to render the elapsed running-timer duration.
//
// Values:
//   data-timer-started-at-value        ISO timestamp the current session started
//   data-timer-previous-seconds-value  (optional) integer seconds already accrued
//                                      across prior stopped sessions on this activity
//
// Targets:
//   clock   — formatted as HH:MM:SS, ticks from previous + live seconds
//   hours   — formatted as X.XXh, the cumulative seconds rounded UP to .25 hours
export default class extends Controller {
  static targets = ["clock", "hours"]
  static values = {
    startedAt: String,
    previousSeconds: { type: Number, default: 0 }
  }

  connect() {
    this.startedAtMs = Date.parse(this.startedAtValue)
    this.tick()
    this.interval = setInterval(() => this.tick(), 1000)
  }

  disconnect() {
    if (this.interval) clearInterval(this.interval)
  }

  tick() {
    if (!this.startedAtMs) return

    const liveSeconds = Math.max(0, Math.floor((Date.now() - this.startedAtMs) / 1000))
    const totalSeconds = this.previousSecondsValue + liveSeconds

    if (this.hasClockTarget) {
      const pad = (n) => String(n).padStart(2, "0")
      const h = Math.floor(totalSeconds / 3600)
      const m = Math.floor((totalSeconds % 3600) / 60)
      const s = totalSeconds % 60
      const text = `${pad(h)}:${pad(m)}:${pad(s)}`
      this.clockTargets.forEach((el) => { el.textContent = text })
    }

    if (this.hasHoursTarget) {
      const rounded = totalSeconds > 0
        ? Math.ceil(totalSeconds / 3600 / 0.25) * 0.25
        : 0
      const text = `${rounded.toFixed(2)}h`
      this.hoursTargets.forEach((el) => { el.textContent = text })
    }
  }
}
